/**
 * HOME-ROUTE
 * IDTREE home page
 */
import NavApp from "@/nav/nav.app"
import HomeSurveysWidget from "@/widgets/home-surveys.widget"
import Space from "@/components/space"
import SurveyHomeWidget from "@/widgets/survey-home.widget"
import { t } from "i18next"
import { useState } from "react"
import SetPasswordModal from "@/modals/set-password.modal"
import { useAppSelector } from "@/core/root-reducer"
import PagePlaceholder from "@/components/page-placeholder"
import { useNavigate } from "react-router-dom"
import HomeActionsPlanWidget from "@/widgets/home-actions-plan.widget"
import RiskAccountHome from "@/entities/physical-risk/ui/RiskAccountHome"
import EstablishmentHome from "@/entities/establishment/ui/EstablishmentHome"

function HomeAccountRoute() {
  const navigate = useNavigate()

  //Selectors
  const settingsExist = useAppSelector((state) => Boolean(state.account.active.accountRisksSettings))
  const _session = useAppSelector((state) => state._session)

  //State
  const [modal, setModal] = useState<"MODAL_SET_PASSWORD" | null>(null)

  //Component to display in the page
  let HomeView: React.ReactNode = null

  //Risks app
  //If no accountRisksSettings redirect to the settings
  if (_session.featureConnected === "risks") {
    if (_session.risksRole === "USER") {
      HomeView = (
        <PagePlaceholder
          image="assistant"
          title={`Vous n’êtes pas administrateur du compte ${_session.accountName}`}
          help="Veuillez contacter le support technique IDTree à l'adresse support@id-tree.com pour demander un accès."
        />
      )
    } else {
      HomeView = !settingsExist ? (
        <PagePlaceholder
          image="assistant"
          button="Configurer le module"
          title="Le module prévention n'est pas configuré"
          help={
            _session.connectedAsSupervisor
              ? undefined
              : "Veuillez contacter le support technique IDTree à l'adresse support@id-tree.com pour configurer le module prévention."
          }
          onClick={_session.connectedAsSupervisor ? () => navigate("/adm/settings") : undefined}
        />
      ) : _session.risksInterfaceType === "ESTABLISHMENT" && !_session.establishmentId ? (
        <PagePlaceholder
          image="assistant"
          button="Configurer un établissement"
          title="Aucun établissement configuré"
          help="Créez un établissement pour commencer à utiliser la prévention des risques."
          onClick={() => navigate("/risks/establishments")}
        />
      ) : _session.risksInterfaceType === "ACCOUNT" ? (
        <RiskAccountHome />
      ) : (
        <EstablishmentHome />
      )
    }
  } else if (_session.featureConnected === "survey") {
    HomeView =
      _session.userRole === "ADMIN" ? (
        <SurveyHomeWidget />
      ) : (
        <div className="flex">
          <Space />
          <div>
            {_session.modules.survey.task && <HomeActionsPlanWidget />}
            <HomeSurveysWidget />
          </div>
          <Space />
        </div>
      )
  }

  if (!HomeView) {
    HomeView = (
      <PagePlaceholder
        image="assistant"
        title="Vous n'avez pas accès à cette application"
        help="Veuillez contacter votre administrateur pour obtenir les droits d'accès nécessaires."
      />
    )
  }

  const showPasswordWarning =
    !_session.userPasswordProvided &&
    _session.supervisorLevel === 0 &&
    _session.connexionMode !== "GOOGLE" &&
    !_session.accountOptions.sso

  return (
    <NavApp>
      {modal === "MODAL_SET_PASSWORD" && <SetPasswordModal onClose={() => setModal(null)} />}

      {HomeView}

      {showPasswordWarning && (
        <div className="flex page-navigation-footer">
          <div style={{ margin: "auto" }}>
            {t("self_password_empty")}&nbsp;
            <span onClick={() => setModal("MODAL_SET_PASSWORD")}>{t("self_password_create")}</span>
          </div>
        </div>
      )}
    </NavApp>
  )
}

export default HomeAccountRoute
